<template>
  <el-pagination
    class="paginator"
    @size-change="setPageSize"
    @current-change="setCurrentPage"
    :current-page="page"
    :page-sizes="[10, 20, 50, 100]"
    :page-size="perPage"
    layout="total, sizes, prev, pager, next, jumper"
    :total="collectionTotal">
  </el-pagination>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    'collectionName': {
      type: String,
      required: true
    }
  },

  computed: {
    collectionTotal () {
      return this.collectionIds.length
    },
    ...mapState({
      collectionIds (state) {
        const cs = state[this.collectionName]
        return cs.sort ? cs.sort.ids : cs.search ? cs.search.ids : cs.ids
      },
      perPage (state) {
        return state[this.collectionName].paginator.perPage
      },
      page (state) {
        return state[this.collectionName].paginator.page
      }
    })
  },

  watch: {
    collectionIds: function () {
      this.filterIds()
    }
  },

  methods: {
    setPageSize (size) {
      this.$store.dispatch(this.collectionName + '/paginator/setPerPage', size)
        .then(this.filterIds)
    },
    setCurrentPage (page) {
      this.$store.dispatch(this.collectionName + '/paginator/setPage', page)
        .then(this.filterIds)
    },
    filterIds () {
      this.$store.dispatch(this.collectionName + '/paginator/filterIds', this.collectionIds)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Paginator.vue